import Media from "@PegasusCore/pegasus-one-media/src/script.js";

class CustomMedia extends Media {
    videoModalOpen = false;
    lottie = null;

    init() {
        super.init();
        const modalVideo = this.$el.querySelector(".modal-video");
        this.lottie = this.$el.querySelector("lottie-player");

        if (!modalVideo && !this.lottie) return;

        this.video = modalVideo;

        if (this.video && this.video.classList.contains("video-embed")) {
            this.videoType = "embed";
        }
    }

    // Controls playing/unmuting when interacting with placeholder layers
    playVideo() {
        if (this.videoType === "upload" && this.video) {
            this.video.play();
        } else if (this.videoType === "embed" && this.video && this.video.contentWindow) {
            // Added check to ensure iframe window exists before posting messages
            this.video.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
            this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
        
        if (this.$refs && this.$refs.videoPlaceholder) {
            this.$refs.videoPlaceholder.classList.add("hidden");
        }
    }

    pauseVideo() {
        if (this.videoType === "upload" && this.video) {
            this.video.pause();
        } else if (this.videoType === "embed" && this.video && this.video.contentWindow) {
            // Added check to ensure iframe window exists before posting messages
            this.video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
        
        if (this.$refs && this.$refs.videoPlaceholder) {
            this.$refs.videoPlaceholder.classList.remove("hidden");
        }
    }

    // Re-added your original intersection logic so Lottie animations keep working
    onIntersect() {
        if (this.lottie) {
            this.playLottie();
        }
    }

    playLottie() {
        setTimeout(() => {
            if (this.lottie && typeof this.lottie.play === 'function') {
                this.lottie.play();
            }
        }, 200);
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("PegasusMediaBlock", () => new CustomMedia());
});
